import React from "react";
import { Card, Row, Col, Statistic, Progress, Table, Typography } from "antd";
import {
  TeamOutlined,
  UserAddOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../store";
import { Navigate } from "react-router-dom";

const { Title } = Typography;

// Data untuk tabel kehadiran
const attendanceData = [
  { key: "1", name: "John Doe", attendance: "90%", late: "5", leave: "2" },
  { key: "2", name: "Jane Smith", attendance: "85%", late: "8", leave: "1" },
  { key: "3", name: "Michael Brown", attendance: "95%", late: "2", leave: "0" },
];

const columns = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Attendance", dataIndex: "attendance", key: "attendance" },
  { title: "Late", dataIndex: "late", key: "late" },
  { title: "Leave", dataIndex: "leave", key: "leave" },
];

const DashboardPage: React.FC = () => {
  const dispatch = useDispatch();
  const { authData, isLogin } = useTypedSelector((state) => {
    return {
      authData: state.Auth.loginData,
      isLogin: state.Auth.isLogin,
    };
  });
  if (!isLogin) {
    return <Navigate to="/login" replace />;
  }
  return (
    <>
      {isLogin && (
        <div style={{ padding: "20px" }}>

          {/* Row 1: Kehadiran dan Statistik Karyawan */}
          <Row gutter={16}>
            <Col span={6}>
              <Card>
                <Statistic
                  title="Total Employees"
                  value={150}
                  prefix={<TeamOutlined />}
                  style={{ textAlign: "center" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <Statistic
                  title="New Hires this month"
                  value={5}
                  prefix={<UserAddOutlined />}
                  style={{ textAlign: "center" }}
                />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <Statistic
                  title="Attendance Rate"
                  value={92}
                  suffix="%"
                  style={{ textAlign: "center" }}
                />
                <Progress percent={92} status="active" />
              </Card>
            </Col>
            <Col span={6}>
              <Card>
                <Statistic
                  title="Turnover Rate"
                  value={3}
                  suffix="%"
                  style={{ textAlign: "center" }}
                />
                <Progress percent={3} status="exception" />
              </Card>
            </Col>
          </Row>

          {/* Row 2: Kehadiran dan Produktivitas */}
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Col span={12}>
              <Card title="Employee Attendance Overview">
                <Table
                  columns={columns}
                  dataSource={attendanceData}
                  pagination={false}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card title="Monthly Productivity">
                <Statistic
                  title="Average Work Hours"
                  value={8.5}
                  suffix="hours/day"
                  prefix={<ClockCircleOutlined />}
                  style={{ textAlign: "center" }}
                />
                <Progress percent={85} success={{ percent: 75 }} />
              </Card>
            </Col>
          </Row>

          {/* Row 3: Performansi dan Pengembangan */}
          <Row gutter={16} style={{ marginTop: 20 }}>
            <Col span={12}>
              <Card title="Performance Highlights">
                <Statistic
                  title="Top Performer Score"
                  value={98}
                  suffix="/ 100"
                  prefix={<BarChartOutlined />}
                  style={{ textAlign: "center" }}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card title="Training & Development">
                <Statistic
                  title="Employees Trained"
                  value={50}
                  suffix="/ 150"
                  style={{ textAlign: "center" }}
                />
                <Progress percent={33} />
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default DashboardPage;
